import * as React from 'react';
import { Link } from '@tanstack/react-router';
import type {SystemConfiguration} from '@/types';

type SystemConfigurationsListProps = {
  systems: SystemConfiguration[]
  systemGroupId: string
  systemGroupRangeId: string
}

export default function SystemConfigurationsList(props: SystemConfigurationsListProps): React.ReactElement | null {
  const generateUrl = (system) => `/systems/${system._id}/configurator`
  if(props.systems) {
    return(
      <div className="flex flex-row flex-wrap gap-4">
        {
          props.systems.map((system: SystemConfiguration): React.ReactElement => {
            return(
              <div key={system._id} className="basis-full flex-none md:basis-1/2 lg:basis-1/3 p-4">
                <Link to={generateUrl(system)}><h3 className="mt-4 text-2xl font-thin">{system.name}</h3></Link>
                {system.description}
              </div>
            )
          })
        }
      </div>
    )
  }
  return null;
}
